import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={15}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={1} fill="var(--theme-background)">
      <path d="m8.541.372-3.15 2.302-.83.606H.754a.595.595 0 0 0-.595.594V8.18c0 .328.267.594.595.594H4.56l.83.607 3.151 2.301c.265.193.48.084.48-.243V.615c0-.327-.215-.436-.48-.243ZM10.499 2.82l-.504.503a3.83 3.83 0 0 1 0 5.409l.504.503a4.543 4.543 0 0 0 0-6.416Z" />
      <path d="m12.066.963-.504.503a6.458 6.458 0 0 1 0 9.122l.504.503c2.793-2.792 2.793-7.336 0-10.128Z" />
    </g>
  </svg>
);

export default SvgComponent;
